import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';




// 封装一个全局请求图片资源的函数
import { requireImg } from '@/utils/requireImg';
Vue.prototype.requireImg = requireImg;

import '@/assets/css/common.scss';

import Loading from 'element-ui/lib/loading';
Vue.use(Loading.directive);

Vue.use(ElementUI);


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
